import React, { createContext, useEffect, useState } from 'react'
import useLocalStorage from 'use-local-storage'
export let context = createContext()
function ContextFun(props) {

    let [value,setValue] = useLocalStorage("signin",{email:"",password:""})
  let [users, setUsers] = useState([])
  let [isLoading,setIsLoading] = useState(false)

  let loadData = async () => {
    let res = await fetch(`https://backend-todolist.vercel.app/getUsers`)
    let json = await res.json()
    setUsers(json)
  }


  useEffect(() => {
    setIsLoading(true)
    loadData().then(()=>setIsLoading(false))
  },[])

  return (
      <context.Provider value={{value,setValue,users, setUsers,loadData,isLoading,setIsLoading}}>{ props.children}</context.Provider>
  )
}

export default ContextFun